import { Injectable } from '@angular/core';
import {
  BathroomCompositionDetailDto,
  CompositionRowDto,
  CompositionColumnDto,
} from 'src/app/models/configurators-2d/mobile/bathroom/bathroom-composition-dtos';

@Injectable({
  providedIn: 'root',
})
export class BathroomPriceService {
  /**
   * Calcule le prix total d'une composition
   */
  calculateTotalPrice(composition: BathroomCompositionDetailDto | null): number {
    if (!composition?.compositionConfiguration) {
      return 0;
    }

    return composition.compositionConfiguration.rows.reduce((total, row) => total + this.calculateRowPrice(row), 0);
  }

  /**
   * Calcule le prix d'une ligne (row)
   */
  private calculateRowPrice(row: CompositionRowDto): number {
    let total = 0;

    // Prix du plan de toilette (coverProduct)
    if (row.coverProduct?.salePrice) {
      total += row.coverProduct.salePrice;
    }

    // Prix de la vasque (basinProduct)
    if (row.basinProduct?.salePrice) {
      total += row.basinProduct.salePrice;
    }

    // Prix des colonnes (meubles + poignées)
    if (row.columns) {
      total += row.columns.reduce((colTotal, column) => colTotal + this.calculateColumnPrice(column), 0);
    }

    return total;
  }

  /**
   * Calcule le prix d'une colonne (meuble + poignée)
   */
  private calculateColumnPrice(column: CompositionColumnDto): number {
    let total = 0;

    if (column.product?.salePrice) {
      total += column.product.salePrice;
    }

    if (column.handle?.salePrice) {
      total += column.handle.salePrice;
    }

    return total;
  }
}
